import React, { useEffect, useMemo, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';

export const TextContent = observer(props => {
  const [text, setText] = useState('');
  const [contentLoaded, setContentLoaded] = useState(false);

  const { settings, environment, replaceTags, orders } = props;
  const { content, hidden } = settings;

  function convertTextToHTML(text) {
    const element = document.createElement('div');
    element.innerHTML = text;

    const paragraphs = element.getElementsByTagName('p');

    // Loop through each <p> tag
    for (var i = 0; i < paragraphs.length; i++) {
      const paragraph = paragraphs[i];

      // Check if the <p> tag contains an <img> tag
      if (paragraph.getElementsByTagName('img').length > 0 && paragraph.style?.textAlign === 'center') {
        paragraph.style.display = 'flex';
        paragraph.style.alignItems = 'center';
        paragraph.style.justifyContent = 'center';
        paragraph.style.width = '100%';

        const images = paragraph.getElementsByTagName('img');
        const spanTags = paragraph.getElementsByTagName('span');
        const strongTags = paragraph.getElementsByTagName('strong');

        for (var j = 0; j < images.length; j++) {
          paragraph.appendChild(images[j]);
        }

        // Remove <span> tags
        while (spanTags.length > 0) {
          spanTags[0].parentNode.removeChild(spanTags[0]);
        }

        // Remove <strong> tags
        while (strongTags.length > 0) {
          strongTags[0].parentNode.removeChild(strongTags[0]);
        }
      }
    }

    return element.innerHTML;
  }

  useEffect(() => {
    const hasTags = content[environment.lang]?.match(/\[[^\]]+\]/g);
    if (hasTags) {
      replaceTags(content[environment.lang]).then(replacedText => {
        const html = convertTextToHTML(replacedText);
        setText(html);
        setContentLoaded(true);
      });
    } else {
      const html = convertTextToHTML(content[environment.lang]);
      setText(html);
      setContentLoaded(true);
    }
  }, [content, environment.lang, orders]);

  const hasTable = useMemo(() => text?.toString()?.includes('<table'), [text]);

  if (hidden) return null;
  if (!contentLoaded) {
    return (
      <div role="status" className="animate-pulse w-full my-2">
        <div className="animate-pulse h-2.5 bg-neutral-200 rounded-full w-48 mb-4"></div>
        <div className="animate-pulse h-2 bg-neutral-200 rounded-full max-w-[80%] mb-2.5"></div>
        <div className="animate-pulse h-2 bg-neutral-200 rounded-full  max-w-full mb-2.5"></div>
        <div className="animate-pulse h-2 bg-neutral-200 rounded-full max-w-[70%] mb-2.5"></div>
        <div className="animate-pulse h-2 bg-neutral-200 rounded-full max-w-[80%] mb-2.5"></div>
        <div className="animate-pulse h-2 bg-neutral-200 rounded-full max-w-[90%]"></div>
      </div>
    );
  }

  return <div style={{ width: '100%', overflow: hasTable ? 'auto' : undefined }} dangerouslySetInnerHTML={{ __html: text?.toString() }} />;
});
